import { render, staticRenderFns } from "./SidebarSide.vue?vue&type=template&id=4b2585a3"
import script from "./SidebarSide.vue?vue&type=script&lang=js"
export * from "./SidebarSide.vue?vue&type=script&lang=js"
import style0 from "./SidebarSide.vue?vue&type=style&index=0&id=4b2585a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports